import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1afde003"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "cropper-container"
}
const _hoisted_3 = {
  key: 1,
  class: "cropper-placeholder"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请选择图片进行裁剪", -1))
const _hoisted_5 = { class: "avatar-upload-preview" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "preview-placeholder"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "预览区域", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 选择 ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-upload el-icon--right" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("提 交")

import { ref, reactive, onMounted, onUnmounted, nextTick, watch } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { VueCropper } from 'vue-cropper'
import { uploadAvatar } from '@/service/main/system/user'
import { debounce } from '@/utils/debounce'

// 类型定义
interface CropperOptions {
  img: string
  autoCrop: boolean
  autoCropWidth: number
  autoCropHeight: number
  fixedBox: boolean
  outputType: string
  filename: string
}

interface PreviewData {
  url?: string
  img?: any
}

interface CropperInstance {
  refresh: () => void
  rotateLeft: () => void
  rotateRight: () => void
  changeScale: (num: number) => void
  getCropBlob: (callback: (data: Blob) => void) => void
}

// 响应式数据

export default /*#__PURE__*/_defineComponent({
  __name: 'userAvatar',
  setup(__props) {

const store = useStore()
const cropperRef = ref<CropperInstance>()

const open = ref<boolean>(false)
const visible = ref<boolean>(false)
const title = ref<string>('修改头像')
const previews = reactive<PreviewData>({})
const resizeHandler = ref<((this: Window, ev: UIEvent) => void) | null>(null)
const isCropperReady = ref<boolean>(false)

const options = reactive<CropperOptions>({
  img: store.getters.avatar || '',
  autoCrop: true,
  autoCropWidth: 200,
  autoCropHeight: 200,
  fixedBox: true,
  outputType: 'png',
  filename: 'avatar'
})

// 监听图片变化
watch(() => options.img, (newImg) => {
  if (newImg && visible.value) {
    nextTick(() => {
      isCropperReady.value = true
    })
  }
})

// 方法定义
const editCropper = (): void => {
  open.value = true
}

const modalOpened = async (): Promise<void> => {
  try {
    await nextTick()
    visible.value = true
    isCropperReady.value = !!options.img
    
    if (!resizeHandler.value) {
      resizeHandler.value = debounce(() => {
        refresh()
      }, 100)
    }
    if (resizeHandler.value) {
      window.addEventListener('resize', resizeHandler.value)
    }
  } catch (error) {
    console.error('Modal opened error:', error)
    ElMessage.error('打开裁剪器失败')
  }
}

const refresh = (): void => {
  try {
    if (cropperRef.value && isCropperReady.value) {
      cropperRef.value.refresh()
    }
  } catch (error) {
    console.error('Refresh error:', error)
  }
}

const requestUpload = (): void => {
  open.value = true
}

const rotateLeft = (): void => {
  try {
    if (cropperRef.value && isCropperReady.value) {
      cropperRef.value.rotateLeft()
    }
  } catch (error) {
    console.error('Rotate left error:', error)
  }
}

const rotateRight = (): void => {
  try {
    if (cropperRef.value && isCropperReady.value) {
      cropperRef.value.rotateRight()
    }
  } catch (error) {
    console.error('Rotate right error:', error)
  }
}

const changeScale = (num: number): void => {
  try {
    if (cropperRef.value && isCropperReady.value) {
      const scale = num || 1
      cropperRef.value.changeScale(scale)
    }
  } catch (error) {
    console.error('Change scale error:', error)
  }
}

const beforeUpload = (file: File): boolean => {
  if (file.type.indexOf('image/') === -1) {
    ElMessage.error('文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。')
    return false
  } else {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      options.img = reader.result as string
      options.filename = file.name
      isCropperReady.value = true
    }
    return false // 阻止默认上传行为
  }
}

const uploadImg = (): void => {
  if (!cropperRef.value || !isCropperReady.value) {
    ElMessage.error('裁剪器未初始化或图片未加载')
    return
  }
  
  try {
    cropperRef.value.getCropBlob((data: Blob) => {
      const formData = new FormData()
      formData.append('avatarfile', data, options.filename)
      
      uploadAvatar(formData).then((response: any) => {
        open.value = false
        options.img = response.imgUrl
        store.commit('SET_AVATAR', options.img)
        ElMessage.success('修改成功')
        visible.value = false
        isCropperReady.value = false
      }).catch((error: any) => {
        ElMessage.error('上传失败，请重试')
        console.error('Upload error:', error)
      })
    })
  } catch (error) {
    console.error('Upload img error:', error)
    ElMessage.error('裁剪失败，请重试')
  }
}

const realTime = (data: PreviewData): void => {
  Object.assign(previews, data)
}

const closeDialog = (): void => {
  options.img = store.getters.avatar || ''
  visible.value = false
  isCropperReady.value = false
  if (resizeHandler.value) {
    window.removeEventListener('resize', resizeHandler.value)
  }
}

// 生命周期
onUnmounted(() => {
  if (resizeHandler.value) {
    window.removeEventListener('resize', resizeHandler.value)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "user-info-head",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (editCropper()))
    }, [
      _createElementVNode("img", {
        src: options.img,
        title: "点击上传头像",
        class: "img-circle img-lg"
      }, null, 8, _hoisted_1)
    ]),
    _createVNode(_component_el_dialog, {
      title: title.value,
      modelValue: open.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((open).value = $event)),
      width: "800px",
      "append-to-body": "",
      onOpened: modalOpened,
      onClose: closeDialog
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              md: 12,
              style: {height: '350px'}
            }, {
              default: _withCtx(() => [
                (visible.value && options.img)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_unref(VueCropper), {
                        ref_key: "cropperRef",
                        ref: cropperRef,
                        img: options.img,
                        info: true,
                        autoCrop: options.autoCrop,
                        autoCropWidth: options.autoCropWidth,
                        autoCropHeight: options.autoCropHeight,
                        fixedBox: options.fixedBox,
                        outputType: options.outputType,
                        onRealTime: realTime
                      }, null, 8, ["img", "autoCrop", "autoCropWidth", "autoCropHeight", "fixedBox", "outputType"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_svg_icon, {
                        "icon-class": "upload",
                        class: "placeholder-icon"
                      }),
                      _hoisted_4
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              md: 12,
              style: {height: '350px'}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  (previews.url)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: previews.url,
                        style: _normalizeStyle(previews.img)
                      }, null, 12, _hoisted_6))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_svg_icon, {
                          "icon-class": "user",
                          class: "preview-icon"
                        }),
                        _hoisted_8
                      ]))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_9,
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              lg: 2,
              sm: 3,
              xs: 3
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  action: "#",
                  "http-request": requestUpload,
                  "show-file-list": false,
                  "before-upload": beforeUpload
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { size: "small" }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              lg: {span: 1, offset: 2},
              sm: 2,
              xs: 2
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  icon: "el-icon-plus",
                  size: "small",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (changeScale(1))),
                  disabled: !isCropperReady.value
                }, null, 8, ["disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              lg: {span: 1, offset: 1},
              sm: 2,
              xs: 2
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  icon: "el-icon-minus",
                  size: "small",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (changeScale(-1))),
                  disabled: !isCropperReady.value
                }, null, 8, ["disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              lg: {span: 1, offset: 1},
              sm: 2,
              xs: 2
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  icon: "el-icon-refresh-left",
                  size: "small",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (rotateLeft())),
                  disabled: !isCropperReady.value
                }, null, 8, ["disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              lg: {span: 1, offset: 1},
              sm: 2,
              xs: 2
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  icon: "el-icon-refresh-right",
                  size: "small",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (rotateRight())),
                  disabled: !isCropperReady.value
                }, null, 8, ["disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              lg: {span: 2, offset: 6},
              sm: 2,
              xs: 2
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (uploadImg())),
                  disabled: !isCropperReady.value
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
}
}

})